import {
    Component,
    Input,
    OnChanges,
    SimpleChanges,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ActionButtonComponent } from "@components/action-button/action-button.component";
import { HeaderComponent } from "@components/header/header.component";
import { InputNumberComponent } from "@components/input-number/input-number.component";
import { DivListComponent } from "@components/list/div-list/div-list.component";
import { ListColumnDirective } from "@components/list/list-column.directive";
import { ListCustomRowDirective } from "@components/list/list-custom-row.directive";
import { SelectorComponent } from "@components/selector/selector.component";
import { SpanComponent } from "@components/span/span.component";
import { TogglePanelComponent } from "@components/toggle-panel/toggle-panel.component";
import { ISelectValue } from "~app/common/models/selectValueModel";
import { AuthenticationService } from "~app/common/services/authentication/authentication.service";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { ArbetsorderDisabledFlag } from "~app/features/planera/model/ArbetsorderDisabledFlag";
import { IArbetsorderDetail } from "~app/features/planera/model/IArbetsorderDetail";
import { IAtgard } from "~app/features/planera/model/IAtgard";
import { IUtbytesberakning } from "~app/features/planera/model/IUtbytesberakning";
import { ArbetsorderDirektutbyteViewModel } from "./arbetsorder-direktutbyte.models";
import { ArbetsorderTradslagsdataComponent } from "./tradslagsdata/arbetsorder-tradslagsdata.component";

@Component({
    selector: "rask-arbetsorder-direktutbyte",
    templateUrl: "./arbetsorder-direktutbyte.component.html",
    styleUrls: ["./arbetsorder-direktutbyte.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        HeaderComponent,
        ActionButtonComponent,
        DivListComponent,
        ListColumnDirective,
        SelectorComponent,
        FormsModule,
        InputNumberComponent,
        SpanComponent,
        ListCustomRowDirective,
        TogglePanelComponent,
        ArbetsorderTradslagsdataComponent
    ]
})
export class ArbetsorderDirektutbyteComponent implements OnChanges {
    @Input() arbetsorder: IArbetsorderDetail;
    @Input() atgard: IAtgard;
    @Input() produktgrupper: ISelectValue[];
    @Input() setFormDirty: () => void;
    vm: ArbetsorderDirektutbyteViewModel;

    private readonly authenticationService = inject(AuthenticationService);
    private readonly hasEditRole: boolean;

    constructor() {
        this.hasEditRole = this.authenticationService.canEdit();
    }

    get addProduktgruppApplicable(): boolean {
        const notApplicable = this.arbetsorder && (this.arbetsorder.isGrotskotning || this.arbetsorder.isLeveransGrot);
        return !notApplicable;
    }

    get atgardMode(): boolean {
        return !ObjectUtils.isNullOrUndefined(this.atgard);
    }

    get canEdit(): boolean {
        return this.hasEditRole && this.arbetsorder?.isEditableForMode(ArbetsorderDisabledFlag.makulerad);
    }

    get visaSkogligInfoApplicable(): boolean {
        const notApplicable = this.arbetsorder && (this.arbetsorder.isGrotskotning || this.arbetsorder.isLeveransvirke);
        return !notApplicable;
    }

    addProduktgrupp(): void {
        this.arbetsorder.utbytesberakningar.push(
            {
                new: true,
                justeradKvantitet: null,
                produktgrupp: "",
                produktgruppId: 0,
                volymM3fub: 0,
                handelssortimentKategori: "",
                handelssortimentsgruppId: null
            });
        this.vm.reRender();

        // TODO: Add new IUtbytesberakning and add create command to commandManager on arbetsorder (when ngjs is no more)
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.atgardMode) {
            this.vm = ArbetsorderDirektutbyteViewModel.createAsAtgard(this.atgard, this.arbetsorder);
        } else {
            this.vm = ArbetsorderDirektutbyteViewModel.createAsArbetsorder(this.arbetsorder, this.produktgrupper);
        }
    }

    onKvantitetChanged(utbyte: IUtbytesberakning): void {
        this.setFormDirty();

        // TODO: Add update command to commandManager on arbetsorder (when ngjs is no more)
    }

    onProduktgruppChanged(utbytesberakning: IUtbytesberakning, idx: number): void {
        if ((utbytesberakning.produktgruppId as any) !== "") {
            return;
        }
        this.arbetsorder.utbytesberakningar.splice(idx);
        this.vm.reRender();
    }

    produktgruppFormatter = (value: ISelectValue) => value ? value.id : "";

    produktgruppViewFormatter = (value: ISelectValue) => value ? `${value.namn}` : null;

}
